import * as ReverseLookup from './_reverseLookup'
import { List, Record } from 'immutable'


const _shape = {
  items: List(),
  table: ReverseLookup.empty,
}


export default class Collection extends Record( _shape ) {
  static get empty() {
    return new Collection()
  }

  static create( Cls, jsonList ) {
    const items = jsonList.map( json => Cls.create( json ))

    return Collection.empty.addItems( items )
  }

  get all() {
    return this.items
  }

  get size() {
    return this.items.size
  }

  addItem( item ) {
    return this.withMutations( state => {
      const i = state.items.size

      return state
        .update( 'items', items => items.push( item ))
        .update( 'table', table => ReverseLookup.add( table, item.id, i ))
    })
  }

  addItems( items ) {
    return this.withMutations( state => {
      for ( const item of items ) {
        state = state
          .update( 'table', table => ReverseLookup.add( table, item.id, state.items.size ))
          .update( 'items', items => items.push( item ))
      }

      return state
    })
  }

  removeById( id ) {
    return this.withMutations( state => {
      const i = ReverseLookup.get( this.table, id ).first()

      return state
        .update( 'items', items => items.remove( i ))
        .update( 'table', table => ReverseLookup.remove( table, id ))
    })
  }

  getById( id ) {
    if( !ReverseLookup.get( this.table, id )) {
      return null
    }
    const i = ReverseLookup.get( this.table, id ).first()

    return this.items.get( i )
  }
}
